module.exports = __webpack_public_path__ + "img/empty.98288858.png";